module.exports = __webpack_public_path__ + "static/ndsu1.94c8afc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/highered_logos/ndsu1.png
// module id = 2191
// module chunks = 61762850755587